// src/pages/public/DonatePage.jsx

// STRIPE DEFAULT COLORS: 33d17a FOR BUTTON AND c0bfbc FOR BACKGROUND
// https://dashboard.stripe.com/acct_1OyLD6KE0e1CFeGp/settings/branding/checkout

// https://dashboard.stripe.com/acct_1OyLD6KE0e1CFeGp/settings/branding



// --- React Hooks ---
import React, { useState } from 'react';

// --- Component Imports ---
import Box from '@mui/material/Box'; // For responsive layout with sx prop

// --- Styles Imports ---
import {
    colors, // Assuming colors is imported from constants via PageStyles or directly
    introHeadingStyles, // For page title
    introSubHeadingStyles, // For general paragraph text
} from 'styles/PageStyles'; // Adjust path based on your setup


import less_alpha_padding_logo from 'pages_centennial/assets/0901/less_alpha_padding_logo.png'






// --- Optional: Import form-specific CSS if you have it ---
// import 'styles/form.css'; // For .form-control styles, including autofill overrides

/**
 * DonatePage: A page component for accepting donations with a Stripe integration overview.
 */
const DonateComponent = () => {



    return (

        <div style={{ margin: '1rem' }}>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '20px',
                    width: '100%',
                    maxWidth: '500px', // Limit form width
                    margin: '2rem auto',
                    padding: '20px',
                    backgroundColor: 'rgba(0, 0, 0, 0.7)',
                    borderRadius: '8px',
                    boxShadow: '0 0 15px rgba(0,0,0,0.5)',
                    border: '1px solid',
                    borderColor: colors.accentColor,
                }}
            >
                <h2 style={{ ...introHeadingStyles, margin: '0px' }}>
                    Join The Mission
                </h2>

                <img
                    src={less_alpha_padding_logo}
                    alt="CENTENNIAL_LOGO_2"
                    style={{
                        maxWidth: '80%',
                        maxHeight: '15rem',
                        margin: '0rem auto',
                        width: 'auto',
                        height: 'auto',
                        objectFit: 'contain',
                    }}
                />
                <p style={{ ...introSubHeadingStyles, textAlign: 'center' }}>
                    If you'd like to support The Wonder Mission in inspiring people of all ages to dream big, explore boldly, and help shape a future where science, awe, and wonder are part of everyday life.
                </p>

                <p style={{ ...introSubHeadingStyles, textAlign: 'center' }}>
                    Your donation will help to promote local and national activities and outreach in support of 'The First Launch Centennial.'
                </p>


                <h2 style={introHeadingStyles}>Make a Donation</h2>



                {/* The simplified form that redirects to Stripe */}
                <Box>
                    <form
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                        }}

                        action="/stripe/create-checkout-session" method="POST">

                        <button
                            type="submit"
                            style={{
                                padding: '1rem 2rem',
                                borderRadius: '1rem',
                                border: 'none',
                                outline: 'none',
                                fontSize: '1.3rem',
                                fontWeight: 'bold',
                                cursor: 'pointer',
                                backgroundColor: '#ADD8E6', // Example color, adjust as needed
                                color: '#000000',
                                transition: 'background-color 0.3s ease',
                            }}
                        >
                            Donate Now
                        </button>
                    </form>
                </Box>
            </Box>
        </div>





    );
};

export default DonateComponent;
